import React from "react";
import { Button } from 'react-vant';
import CircleAnimation from "../circle_animation/CircleAnimation";
import 'animate.css';
import "../animate/slide_top.css";
import "../animate/scale_in_ver_top.css";
import "../animate/slide_in_left.css";

const playAudioimg = require("../../../assets/img/play_audio.png");
const stopAudioimg = require("../../../assets/img/stop_audio.gif");
import { getTarotPopup } from "./locale";
import fill_in_information from '../../../assets/update_new/fill_in_information_icon.svg'; // 适当调整路径
import arrow_right from '../../../assets/update_new/arrow_right.svg';

import love from '../../../assets/update_new/love_option.svg';
import career from '../../../assets/update_new/carrer_option.svg';
import wealth from '../../../assets/update_new/waalth_option.svg';
import family from '../../../assets/update_new/family_option.svg';


const AiMessage = ({ avator, content, category, chooseTarot, showCursor, length, index, locale, moreContent, cesuan_hide_key, isShowDetail, showMore, playAudio, stopAudio, playAudioIndex, showAudioLoading, showFillInInformation, cesuanType }) => {

    // 将文本按 "\n\n" 分割成多个段落
    let paragraphs = '';
    if (moreContent && moreContent != '') {
        paragraphs = moreContent.split('\n\n');
    }
    const DivisionMessage = ({ content, index, playAudioIndex }) => {
        return (
            <div className="ai_content_message" style={{ marginTop: '30px', display: 'grid', marginLeft: '46px' }}>
                <div className="message_p">
                    <span dangerouslySetInnerHTML={{ __html: content }} />
                </div>
                <div style={{
                    position: 'absolute',
                    marginTop: '-35px',
                    height: '26px', left: '46px',
                    display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row',
                    display: 'none'
                }}>
                    <div className="div_audio" style={{
                        width: '51px', height: '26px',
                        background: 'linear-gradient(360deg, #0099D4 0%, #00B9FF 100%)',
                        borderRadius: '12px 12px 12px 0px',
                        backgroundSize: 'cover', backgroundRepeat: 'no-repeat',
                        display: 'flex', justifyContent: 'center', alignItems: 'center'
                    }}>
                        {playAudioIndex == index && (
                            <img onClick={() => stopAudio(true)} src={stopAudioimg} style={{ width: '26px', height: '26px', padding: '5px', boxSizing: 'border-box', margin: 'auto' }}></img>
                        )}
                        {playAudioIndex != index && (
                            <img onClick={() => playAudio(content, index)} src={playAudioimg} style={{ width: '26px', height: '26px', padding: '5px', boxSizing: 'border-box', margin: 'auto' }}></img>
                        )}
                    </div>
                    {playAudioIndex == index && showAudioLoading && (
                        <span style={{ color: 'white', marginLeft: '10px', textAlign: 'center' }}>Hold on for a few seconds.</span>
                    )}
                </div>
            </div>
        )
    };
    return (
        <div className="ai_content slide-in-left" style={{ flexDirection: isShowDetail ? 'column' : 'row' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <img src={avator} style={{ width: '36px', height: '36px', marginRight: '10px', borderRadius: '50%' }} />
                <div className={`ai_content_message`}>
                    <div className="message_p">
                        <span dangerouslySetInnerHTML={{ __html: content }} />{length - 1 == index && showCursor && (<CircleAnimation />)}
                    </div>
                    {((category == '9000') && !isShowDetail && (
                        <div className="hide_message" onClick={() => showMore(index, '', cesuan_hide_key)}>
                            <span className="hide_name">View More Details</span>
                            <img className="hide_img"
                                src={require('../../../assets/img/hide_img.png')} />
                        </div>
                    ))}
                    {((category == '3003' && length - 1 != index) || (category == '3003' && !showCursor)) && (
                        <div className="animationClass" style={{ display: 'inline-block' }}>
                            <div className="divider"></div>
                            <div className="div_choose" translate="no" onClick={length - 1 == index ? chooseTarot : undefined}>
                                <Button className="chooseTarot" color='#d99b3d'> {getTarotPopup(locale)[1]} </Button>
                            </div>
                            <div className="div_choose_pc" translate="no" onClick={length - 1 == index ? chooseTarot : undefined}>
                                <Button className="chooseTarot" color='#d99b3d'> {getTarotPopup(locale)[1]} </Button>
                            </div>
                        </div>
                    )}
                    {((category == '1002' || category == '2001' || category == '3001' || category == '3002' || category == '2003') && !showCursor && (
                        <div>
                            <div onClick={showFillInInformation}
                                style={{ width: '100%', display: 'flex', flexDirection: 'row', background: 'linear-gradient(90deg, #FFBC41 0%, #FFCE6C 50%, #FFDA90 100%)', borderRadius: '10px', alignItems: 'center', marginTop: '15px' }}>
                                <img style={{ width: '20px', height: '20px', margin: '10px', }} src={fill_in_information}></img>
                                <span style={{ color: 'rgba(63, 37, 0, 1)', fontSize: '13px', fontWeight: '500' }}>Tell me, when were you born?</span>
                                <img style={{ width: '7px', height: '13.5px', marginLeft: 'auto', marginRight: '10px' }} src={arrow_right}></img>
                            </div>
                            <div style={{ marginTop: '10px', fontSize: '12px', color: '#d9d9d9', fontWeight: 400, background: 'rgba(1, 82, 113, 1)', padding: '10px', borderRadius: '10px', fontFamily: 'Roboto' }}>
                                <span style={{ fontSize:'15px' }}><span style={{ color: 'rgb(217, 155, 61)',fontWeight:'bold',fontSize:'16px' }}>Tips:</span> Your privacy is protected in line with our policy, Please feel confident providing your information.</span>
                            </div>
                        </div>
                    ))}
                    {(content == "Great, I've displayed your birth chart. Is there anything you'd like to know?" || category == '1111') && (
                        <div style={{ marginTop: '20px' }}>
                            <img src={love} style={{ marginRight: '10px' }} onClick={() => cesuanType('love')}></img>
                            <img src={career} onClick={() => cesuanType('career')}></img>
                            <img src={wealth} style={{ marginRight: '10px' }} onClick={() => cesuanType('wealth')}></img>
                            <img src={family} onClick={() => cesuanType('family')}></img>
                        </div>
                    )}
                </div>
            </div>
            {((length - 1 != index) || (length - 1 == index && !showCursor)) && (
                <div style={{
                    position: 'absolute',
                    top: '-20px',
                    left: '46px',
                    height: '26px',
                    display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row',
                    display: 'none'
                }}>
                    <div className="div_audio" style={{
                        width: '51px', height: '26px',
                        background: 'linear-gradient(360deg, #0099D4 0%, #00B9FF 100%)',
                        borderRadius: '12px 12px 12px 0px',
                        backgroundSize: 'cover', backgroundRepeat: 'no-repeat',
                        display: 'flex', justifyContent: 'center', alignItems: 'center'
                    }}>
                        {playAudioIndex == index && (
                            <img onClick={() => stopAudio(true)} src={stopAudioimg} style={{ width: '26px', height: '26px', padding: '5px', boxSizing: 'border-box', margin: 'auto' }}></img>
                        )}
                        {playAudioIndex != index && (
                            <img onClick={() => playAudio(content, index)} src={playAudioimg} style={{ width: '26px', height: '26px', padding: '5px', boxSizing: 'border-box', margin: 'auto' }}></img>
                        )}
                    </div>
                    {playAudioIndex == index && showAudioLoading && (
                        <span style={{ color: 'white', marginLeft: '10px', textAlign: 'center' }}>Hold on for a few seconds.</span>
                    )}
                </div>
            )}
            <div>
                {category == '9000' && moreContent != '' && isShowDetail && (
                    paragraphs.map((paragraph, index) => (
                        <DivisionMessage key={index} content={paragraph} index={99 + index} playAudioIndex={playAudioIndex} />
                    ))
                )}
            </div>
        </div>
    )
}
export default AiMessage;